<svg xmlns="http://www.w3.org/2000/svg" width="30" height="33" viewBox="0 0 30 33">
  <g id="Remote_Control_Icon" data-name="Remote Control Icon" transform="translate(-990 -3004)">
    <g id="Ellipse_4" data-name="Ellipse 4" transform="translate(990 3004)" fill="none" stroke="#ffaa31" stroke-width="3">
      <circle cx="15" cy="15" r="15" stroke="none"/>
      <circle cx="15" cy="15" r="13.5" fill="none"/>
    </g>
    <g id="Ellipse_5" data-name="Ellipse 5" transform="translate(996 3010)" fill="none" stroke="#ffaa31" stroke-width="3">
      <circle cx="9" cy="9" r="9" stroke="none"/>
      <circle cx="9" cy="9" r="7.5" fill="none"/>
    </g>
    <circle id="Ellipse_6" data-name="Ellipse 6" cx="3" cy="3" r="3" transform="translate(1002 3016)" fill="#ffaa31"/>
    <g id="Group_32" data-name="Group 32">
      <path id="Polygon_3" data-name="Polygon 3" d="M10.083,3.287a3,3,0,0,1,4.834,0l6.57,8.936A3,3,0,0,1,19.07,17H5.93a3,3,0,0,1-2.417-4.777Z" transform="translate(992.5 3020)" fill="#fff"/>
      <path id="Polygon_4" data-name="Polygon 4" d="M5.874,2.285a1.7,1.7,0,0,1,2.877,0L12.985,9.01a1.7,1.7,0,0,1-1.439,2.606H3.079A1.7,1.7,0,0,1,1.64,9.01Z" transform="translate(997.688 3022.692)" fill="#ffe5c1"/>
    </g>
  </g>
</svg>
